import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Menu from './Menu';
import ContactFooter from './ContactFooter';
import '../assets/sass/main.scss';

class Container extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPreloaded: true
    };
    this.isMenuOpen = this.isMenuOpen.bind(this);
  }

  componentDidMount() {
    this.timeoutId = setTimeout(() => {
      this.setState({ isPreloaded: false,
        menuOpen: false });
    }, 100);
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  isMenuOpen(isMenuOpen) {
    this.setState({ menuOpen: isMenuOpen });
  }

  render() {
    const {children } = this.props;
    const { isPreloaded, menuOpen } = this.state;

    return (
      <>
        <div style={{
            height:'auto !important',
            minHeight: '9vh',
            display:'flex',
            position:'sticky',
            top: 0,
            flexDirection:'column', 
            margin:'0',
            zIndex: 100,
          }}>
          <Menu isMenuOpen={this.isMenuOpen}/>
        </div>  
        {!menuOpen && (<div  style={{
            height:'auto !important',
            minHeight: '100vh',
            display:'flex',
            flexDirection:'column', 
            margin:' 0 auto -155px', 
            overflowX:'hidden',
            zIndex: '100',
          }}
          >

        <div className={isPreloaded ? 'is-preload' : ''}     
              style={{
            transition: 'transform .5s ease-out',
            zIndex:1,
            position:'relative',
            display: 'block'
          }}>
            {children}
          </div>
          <ContactFooter/>
      </div>)}


      </>
    );
  }
}

Container.propTypes = {
  children: PropTypes.node.isRequired,
  logo: PropTypes.string
};

export default React.memo(Container);
